/* eslint-disable require-jsdoc */
import React, {Fragment} from 'react';

import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import {withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import stats from '../../api/stats';

import styles from './style';


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return {hasError: true};
  }

  componentDidCatch(error, errorInfo) {
    stats.pushStat(stats.METRIC.GET_MSG, stats.STATUS.FAIL, 'generalRender');
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Render any custom fallback UI
      return (
        <Fragment>
          <CssBaseline />
          <Container component="main" maxWidth="sm">
            <Typography
              variant="h5"
              align="center"
              classes={this.props.classes}
            >
              Something went wrong, please try again later.
            </Typography>
          </Container>
        </Fragment>
      );
    }

    return this.props.children;
  }
}
export default withStyles(styles, {withTheme: true})(ErrorBoundary);
